export const menuIndices = function (el) {
    el.querySelectorAll("li").forEach(function (element, x) {
        element.style.setProperty("--index", x);
    });
};
